(function () {
    'use strict';

    angular
        .module('dialog-manager')
        .factory('action-dm-set-data', actionSetDialogData);

    function actionSetDialogData($q, lodash, DialogManager) {
        return function (options) {
            return $q.when(run());

            function run() {
                const dialogId = lodash.get(options, 'dialogId', null);
                if (!dialogId) return false;
                const path = lodash.get(options, 'path', '');
                const value = lodash.get(options, 'value', null);
                return DialogManager.setData(dialogId, path, value);
            }
        };
    }
})();
